import { BrowserRouter, Route, Routes } from "react-router-dom";
import HomePageOne from "./pages/HomePageOne";
import ErrorPage from "./pages/ErrorPage";
import RouteScrollToTop from "./helper/RouteScrollToTop";
import PrivateRoute from "./components/PrivateRoute";
import SignInPage from "./pages/SignInPage";
import { useDispatch } from "react-redux";
import { hydrateAuth, setUser } from "./redux/slices/authSlice";
import { useEffect } from "react";
import ManageCategoryPage from "./pages/ManageCategoryPage";
import UsersListPage from "./pages/UsersListPage";
import ManageAdminPage from "./pages/ManageAdminPage";
import ContactListPage from "./pages/ContactListPage";
import NotificationPage from "./pages/NotificationPage";
import AdminMessagesPage from "./pages/AdminMessagesPage";
import MyAppointmentsPage from "./pages/MyAppointmentsPage";
import VendorBookingsPage from "./pages/VendorBookingsPage";
import { getAuth } from "./utils/authStorage";
import VendorProfilePage from "./pages/VendorProfilePage";
import EditVendorProfliePage from "./pages/EditVendorProfliePage";
import AllBookingsPage from "./pages/AllBookingsPage";
import AddEditProductPage from "./pages/AddProductPage"
import ProductListPage from "./pages/ProductListPage";
import AddProductPage from "./pages/AddProductPage";
import EditProductPage from "./pages/EditProductPage";
import VendorBillsPage from "./pages/VendorBillsPage";
import EditVendorBillPage from "./pages/EditVendorBillPage";
import CreateBillPage from "./pages/CreateBillPage";
import BillInvoicePreviewPage from "./pages/BillInvoicePreviewPage";
import InventoryHistoryPage from "./pages/InventoryHistoryPage";
import ManageInvoiceDetailPage from "./pages/ManageInvoiceDetailPage";
import VendorsListPage from "./pages/VendorsListPage";
import ManageProductCategoryPage from "./pages/ManageProductCategoryPage";
import ManageCustomerReturnPage from "./pages/ManageCustomerReturnPage";
import AddBlogPage from "./pages/AddBlogPage";
import BlogCategoryPage from "./pages/BlogCategoryPage";
import EditBlogPage from "./pages/EditBlogPage";
import BlogListPage from "./pages/BlogListPage";


function App() {

  const dispatch = useDispatch();

  useEffect(() => {
    const { token, user } = getAuth();

    if (token && user) {
      dispatch(hydrateAuth({ token, user }));
    }
  }, [dispatch]);



  return (

    <BrowserRouter>

      <RouteScrollToTop />

      <Routes>

        <Route path="/login" element={<SignInPage />} />

        {/* 🔐 Protected Routes */}
        <Route element={<PrivateRoute />}>
          <Route path="/" element={<HomePageOne />} />
        </Route>

        <Route element={<PrivateRoute />}>
          <Route path="/my-profile" element={<VendorProfilePage />} />
        </Route>

        <Route element={<PrivateRoute />}>
          <Route path="/edit-vendor-profile/:vendorId" element={<EditVendorProfliePage />} />
        </Route>

        <Route element={<PrivateRoute />}>
          <Route path="/my-bookings" element={<VendorBookingsPage />} />
        </Route>

        <Route element={<PrivateRoute />}>
          <Route path="/inventory-history" element={<InventoryHistoryPage />} />
        </Route>

        <Route element={<PrivateRoute />}>
          <Route path="/my-bills" element={<VendorBillsPage />} />
        </Route>

        <Route element={<PrivateRoute />}>
          <Route path="/bill/preview/:billId" element={<BillInvoicePreviewPage />} />
        </Route>

        <Route element={<PrivateRoute />}>
          <Route path="/bill/create" element={<CreateBillPage />} />
        </Route>

        <Route element={<PrivateRoute />}>
          <Route path="/bill/edit/:billId" element={<EditVendorBillPage />} />
        </Route>

        <Route element={<PrivateRoute />}>
          <Route path="/my-appointments" element={<MyAppointmentsPage />} />
        </Route>

        <Route element={<PrivateRoute />}>
          <Route path="/manage-product" element={<ProductListPage />} />
        </Route>

        <Route element={<PrivateRoute />}>
          <Route path="/add-product" element={<AddProductPage />} />
        </Route>

        <Route element={<PrivateRoute />}>
          <Route path="/edit-product/:id" element={<EditProductPage />} />
        </Route>

        <Route element={<PrivateRoute />}>
          <Route path="/manage-invoice" element={<ManageInvoiceDetailPage />} />
        </Route>

        {/* Admin   */}

        <Route element={<PrivateRoute />}>
          <Route path="/manage-categories" element={<ManageCategoryPage />} />
        </Route>

        <Route element={<PrivateRoute />}>
          <Route path="/all-users" element={<UsersListPage />} />
        </Route>

        <Route element={<PrivateRoute />}>
          <Route path="/manage-admin" element={<ManageAdminPage />} />
        </Route>

        <Route element={<PrivateRoute />}>
          <Route path="/vendors-list" element={<VendorsListPage />} />
        </Route>

        <Route element={<PrivateRoute />}>
          <Route path="/contacts" element={<ContactListPage />} />
        </Route>

        <Route element={<PrivateRoute />}>
          <Route path="/notifications" element={<NotificationPage />} />
        </Route>

        <Route element={<PrivateRoute />}>
          <Route path="/admin-message" element={<AdminMessagesPage />} />
        </Route>

        <Route element={<PrivateRoute />}>
          <Route path="/all-bookings/" element={<AllBookingsPage />} />
        </Route>

        <Route element={<PrivateRoute />}>
          <Route path="/vendor-profile/:vendorProfileId" element={<VendorProfilePage />} />
        </Route>

        <Route element={<PrivateRoute />}>
          <Route path="/manage-product-category/" element={<ManageProductCategoryPage />} />
        </Route>

        <Route element={<PrivateRoute />}>
          <Route path="/manage-customer-return/" element={<ManageCustomerReturnPage />} />
        </Route>

        <Route element={<PrivateRoute />}>
          <Route path="/add-blog" element={<AddBlogPage />} />
        </Route>

        <Route element={<PrivateRoute />}>
          <Route path="/edit-blog/:id" element={<EditBlogPage />} />
        </Route>

        <Route element={<PrivateRoute />}>
          <Route path="/all-blogs" element={<BlogListPage />} />
        </Route>

        <Route element={<PrivateRoute />}>
          <Route path="/manage-blog-categories" element={<BlogCategoryPage />} />
        </Route>

        {/* ❌ Fallback */}
        <Route path="*" element={<ErrorPage />} />

      </Routes>

    </BrowserRouter>

  );
}

export default App;
